module.exports = __webpack_public_path__ + "img/belarus.74dc1ef6.png";